module.exports = __webpack_public_path__ + "img/choice.94211fb5.svg";